import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

window.customElements.define('buyside-csv-uploader', wrap(Vue, () => import('~root/src/bundle/CsvUploader.vue?shadow')))

window.customElements.define('buyside-current-value-estimate', wrap(Vue, () => import('~root/src/bundle/CurrentValueEstimate.vue?shadow')))

window.customElements.define('buyside-featured-buyers-searching', wrap(Vue, () => import('~root/src/bundle/FeaturedBuyersSearching.vue?shadow')))

window.customElements.define('buyside-market-activity', wrap(Vue, () => import('~root/src/bundle/MarketActivity.vue?shadow')))

window.customElements.define('buyside-my-equity', wrap(Vue, () => import('~root/src/bundle/MyEquity.vue?shadow')))

window.customElements.define('buyside-partner-ad', wrap(Vue, () => import('~root/src/bundle/PartnerAd.vue?shadow')))

window.customElements.define('buyside-state-funnel', wrap(Vue, () => import('~root/src/bundle/StateFunnel.vue?shadow')))

window.customElements.define('buyside-supply-side-trends', wrap(Vue, () => import('~root/src/bundle/SupplySideTrends.vue?shadow')))

window.customElements.define('buyside-theme', wrap(Vue, () => import('~root/src/bundle/Theme.vue?shadow')))